<template>
  <DashboardPage>
    <PageBreadcrumb
      :crumbs="[{
        label: $t('calendar.calendar')
      }]"
    />

    <SpinningLoader :pending="pending">
      <div class="sm:container mx-2 sm:mx-auto">
        <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
          <AsteonlineCard
            v-for="calendar in calendars"
            :key="'auction-calendar-' + calendar.uuid"
          >
            <CardHead>
              <CalendarIcon class="h-4 w-4 inline-block" />
              {{ calendar.name }}
            </CardHead>
            <CardBody class="h-[100px]">
              <p>
                {{ $t("auction.will_open_at") }}
                {{ dateUtils.formatDate(calendar.startAt) }}<br>
                {{ $t("auction.at_time") }}
                {{ dateUtils.formatTime(calendar.startAt) }}
              </p>
              <p class="mt-2">
                <b>{{ JSON.parse(calendar.category.multilangName)[$i18n.locale] }}</b>
              </p>
            </CardBody>
          </AsteonlineCard>
        </div>
      </div>
    </SpinningLoader>
  </DashboardPage>
</template>

<script setup>
import { CalendarIcon} from '@heroicons/vue/24/outline'
import { ref } from 'vue'

import AsteonlineCard from '@/components/card/AsteonlineCard.vue';
import CardBody from '@/components/card/CardBody.vue';
import CardHead from '@/components/card/CardHead.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import PageBreadcrumb from '@/components/PageBreadcrumb.vue';
import SpinningLoader from '@/components/SpinningLoader.vue';
import useAxios from '@/composables/axios';
import dateUtils from '@/services/date-utils';

const axios = useAxios()

let pending = ref(true)
let calendars = ref([])

axios.get('/auction-calendar-entry/list').then((resp) => {
    calendars.value = resp.data
    pending.value = false;
}).catch(() => {
    
})

</script>